import { render, staticRenderFns } from "./Cancer.vue?vue&type=template&id=efa7f962&"
import script from "./Cancer.vue?vue&type=script&lang=js&"
export * from "./Cancer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports